import { PROPERTY, Property, IProperty } from '@clooper/core';
import { Pipe, PipeTransform } from '@angular/core';
/**
  * OccupancyTypePipe
  *
  * A pipe that returns occupancyType of a property.
  */
@Pipe({ name: 'occupancyType' })
export class OccupancyTypePipe implements PipeTransform {
  /**
  * Returns occupancyType of a property.
  * @param {IProperty|Property} property A property Object.
  * @param {string} actionType A opitonal action type.
  * @return {string} Returns occupancy type.
  */
  transform(property: IProperty | Property, actionType = 'getName'): string | boolean {
    const result: any = property.occupancy_type === PROPERTY.OCCUPANCY_TYPES.SINGLE ? 'Entire' : 'Shared';
    if (actionType == 'isSingle') {
      return result === 'Single';
    } else if (actionType == 'isShared') {
      return result === 'Shared';
    }
    return result;
  }
}
